import YearPersonReport from './year-person-report.vue'
export default YearPersonReport
